import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Field from "../../../common/components/Field";
import { initialValues } from "./values";
import { loginFormValidationSchema } from "./validation";
import { Formik } from "formik";
import { Grid, Button } from "@material-ui/core";

import styles from "./styles";

const CreatePassword = ({
  classes,
  onRequestSend,
  token,
  isLoading,
  message,
}) => {
  return (
    <Formik
      initialValues={initialValues()}
      validationSchema={loginFormValidationSchema}
    >
      {(formik) => (
        <Grid>
          <Field
            className={classes.textField}
            type="password"
            label="Senha"
            name="password"
            formik={formik}
          />
          <Field
            className={classes.textField}
            type="password"
            label="Confirmar Senha"
            name="passwordConfirmation"
            formik={formik}
          />
          <Button
            onClick={() => onRequestSend(formik.values, token)}
            className={classes.button}
          >
            Cadastrar Senha
          </Button>
        </Grid>
      )}
    </Formik>
  );
};

export default withStyles(styles)(CreatePassword);
